var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfilearrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.6,
    fill: "white",
    stroke: "url(#paint0_linear_3283_16119)",
    strokeWidth: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.95837 7.91683L14.0417 12.0002L9.95837 16.0835",
    stroke: "url(#paint1_linear_3283_16119)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3283_16119",
    x1: 12.529,
    y1: 24.7993,
    x2: 4.33992,
    y2: 16.8561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9DB",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1976D2",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3283_16119",
    x1: 14.1777,
    y1: 11.8202,
    x2: 11.9751,
    y2: 12.9555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A9DB",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1976D2",
    stopOpacity: 0.75
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilearrow);
export default __webpack_public_path__ + "static/media/profilearrow.ad06235249300fc7ba97c7f4960adba0.svg";
export { ForwardRef as ReactComponent };